export default __webpack_public_path__ + "static/media/menu-users.602db912.svg";